import { render } from "./App.vue?vue&type=template&id=c9659b94&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c9659b94&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9659b94"]])

export default __exports__